import React from 'react';

import PrivateRoute from 'components/Navigation/ProtectedRoute';
import SolidButton from 'components/SolidButton';

import { BUTTON_COLORS } from 'utils/enums';
import { useForm } from 'react-hook-form';
import BaseInput from 'components/Inputs/BaseInput';
import { REQUIRED_RULE } from 'utils/constants';

export default function BulkMailPage() {
  const {
    register,
    formState: { errors },
  } = useForm();

  const buildBaseInput = (
    label: string,
    type: React.HTMLInputTypeAttribute,
    name: string,
    rules: any,
    props: any
  ) => {
    return (
      <BaseInput
        label={label}
        type={type}
        name={name}
        register={register}
        errors={errors}
        rules={rules}
        {...props}
      />
    );
  };
  return (
    <PrivateRoute>
      <div className="text-[#1B205A]">
        <div className="pb-8 2xl:px-24">
          <div className="mt-6 justify-between space-y-4 px-8 pb-4 sm:flex sm:space-y-0">
            <p className="text-2xl font-bold">Mensaje masivo</p>
          </div>
          <div className="bg-white shadow sm:rounded-lg">
            <div className="space-y-6 px-4 py-6">
              {buildBaseInput('Título', 'text', 'title', REQUIRED_RULE, {})}
              {buildBaseInput('Mensaje', 'textarea', 'message', REQUIRED_RULE, {})}
            </div>
            <div className="flex justify-center bg-gray-50 py-4 px-8 sm:rounded-b-lg">
              <SolidButton color={BUTTON_COLORS.BLUE} className="w-auto px-12">
                Enviar
              </SolidButton>
            </div>
          </div>
        </div>
      </div>
    </PrivateRoute>
  );
}
